import { render, staticRenderFns } from "./HeatmapSwipe.vue?vue&type=template&id=5ec97318"
import script from "./HeatmapSwipe.vue?vue&type=script&lang=js"
export * from "./HeatmapSwipe.vue?vue&type=script&lang=js"
import style0 from "./HeatmapSwipe.vue?vue&type=style&index=0&id=5ec97318&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports